import { map } from '../../components/map/src';

const getZoom = () => map?.getView().getZoom();

export const info = {
    getZoom,
};

export default info;
